import { IAttachedFile } from 'src/design/organisms/attachments/attachmentTypes';

export interface IUploadFailure {
  file: File;
  error: unknown;
}

export interface IUploadBatchResult {
  /** Successful uploads, in the order the files were dropped. */
  uploaded: IAttachedFile[];
  failures: IUploadFailure[];
}

/** @registry Uploads a dropped batch of files, keeping the ones that landed even when siblings fail — a partial failure must never discard files the server already stored. */
export const uploadBatch = async (
  files: File[],
  uploadFile: (file: File) => Promise<IAttachedFile>,
): Promise<IUploadBatchResult> => {
  const settled = await Promise.allSettled(
    files.map((file) => uploadFile(file)),
  );
  const uploaded: IAttachedFile[] = [];
  const failures: IUploadFailure[] = [];
  settled.forEach((result, index) => {
    if (result.status === 'fulfilled') uploaded.push(result.value);
    else failures.push({ file: files[index], error: result.reason });
  });
  return { uploaded, failures };
};
